import { saveUserVerification } from './UserVerificationService';
import {extractError} from '../../api/ErrorUtil';

export const userVerificationFormDataInitialState = {
    verificationCode: "",
    email: "",
    readOnly: false,
    status: "",
    verificationSuccessful: false,
    errors: {}
  }
  
  export const UserVerificationFormDataReducer = (state, action) => {
  

    if (action.type === 'FORM_SUBMIT') {
      let {formData, successFunction, failureFunction} = action.payload;
      saveUserVerification(formData, successFunction, failureFunction);
      return {
        ...state,
        readOnly: true,
        status: "Verifying user...",
        errors: {}
      }
    }
  
    if (action.type === 'FORM_SUBMIT_SUCCESS') {
      let data = action.payload;
      let newState = {
        ...userVerificationFormDataInitialState,
        status:"",
        readOnly: true,
        verificationSuccessful: true,
        infoMessage: data.message
      };
      return newState;
    }
  
    if (action.type === 'FORM_SUBMIT_FAIL') {
      let error = extractError(action.payload);
      let newState = {
        ...state,
        status:"",
        readOnly:false,
        errors: error
      };
      return newState;
    }
  
    //the following is for form edit and hence there should be a payload.
    //otherwise just return state
  
    if (!action.payload) {
      return state;
    }
    if (action.type === 'FIELD_EDIT') {
      const { name, value } = action.payload;
      let newState = {
        ...state,
        [name]: value
  
      };
      return newState;
    }
  }
  